import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToolsService } from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class Base2Service {

  private urlBase: string = "https://api.fulleapps.io/";

  constructor(
    private http: HttpClient,
    private tools: ToolsService,
   
  ) { }

  postBase(endUrl: string, params?: any, userKey?: string, noheader: boolean = false): Promise<any> {

    const that = this;

    return new Promise(function (resolve, reject) {

      const headers = noheader ? {} : {
        headers: {
          "Authorization": "Mutual " + (userKey ? userKey : that.tools.getStor("user_id")),
        }
      }

      that.http.post(that.urlBase + endUrl, params, headers)

        .toPromise().then(data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        })

    });

  }

  getBase(endUrl: string, params?: any, userKey?: any, noheader: boolean = false): Promise<any> {

    const that = this;

    return new Promise(function (resolve, reject) {

      const headers = noheader ? {} : {
        headers: {
          "Authorization": "Mutual " + (userKey ? userKey : that.tools.getStor("user_id")),
        }
      };

      params = (params) ? "?" + that.serializeParams(params) : "";

      that.http.get(that.urlBase + endUrl + params, headers)

        .toPromise().then(data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        })


    });
  }

  serializeParams(json: any) {
    let urlParameters = Object.entries(json).map(e => {
      if (typeof e[1] === "object") {
        e[1] = JSON.stringify(e[1]);
      }
      return e.join('=');
    }).join('&');

    return urlParameters;
  }

}
